export const selectedObjectId = payload => ({
    type: 'ON_SELECTED_MARKER_ID',
    payload: payload
})

export const selectedObjectIdNull = () => ({
    type: 'ON_SELECTED_MARKER_ID_NULL',
})